import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService, LoaderService } from 'src/app/services';

@Component({
  selector: 'app-acknowledgement',
  templateUrl: './acknowledgement.component.html',
  styleUrls: ['./acknowledgement.component.scss']
})
export class AcknowledgementComponent implements OnInit {
  list:any="";
  showLoader;
  bookingID: FormGroup; // = 337 this is for hardcode testing
  constructor(public http: HttpService, public loaderService: LoaderService, private router: Router, private route: ActivatedRoute,
    private fb: FormBuilder,) {
    route.params.subscribe((params) => {
      this.bookingID = this.fb.group ({
        id: (params['id']),
      });
    });
  }
  ngOnInit(): void {

    this.http.hotelget(`booking/booking-detail?booking_id=${this.bookingID.value.id}`).subscribe ((res) => {
      if (res.statusCode === 200) {
        this.list = res.data.details;
      }
    })
  }


  bookingConfirmation(){
  }
}
